import {Dialog, DialogActions, DialogContent, Typography} from "@material-ui/core";
import {Button, useListContext, useNotify, useRefresh,} from "react-admin";
import {useToggler} from "../../shared/hooks/useToggler";
import {generateError} from "../../shared/utils";
import IconCancel from "@material-ui/icons/Cancel";
import UpdateIcon from "@material-ui/icons/Update";
import {useState} from "react";
import {client} from "../../dataProvider";


export const DuplicatePermittForAllBulkButton = () => {

  const { selectedIds, refetch, onSelect } = useListContext();
  const { value, setFalse, setTrue } = useToggler();
  const refresh = useRefresh();
  const notify = useNotify();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    setLoading(true);

    client(`workpermits/bulk_duplicate_permitt_for_all`, {
      method: "POST",
      data: {
        ids: selectedIds,
      }
    }).then((response) => {
      if (response.data && response.data.employee_errors > 0) {
        let mess = "Permessi duplicati per tutti, ma "
        for (let i = 0; i < response.data.employee_errors; i++) {
          if (i > 0) mess += ", ";
          mess += response.data.employee_errors[i];
        }
        mess = " permessi non sono stati duplicati per mancanza di dipendenti";

        notify(mess, { type: "warning" });
      }
      else {
        notify("Permessi duplicati per tutti");
      }
      onSelect([]);
    })
      .catch((error) => {
        generateError(error, notify);
      })
      .finally(() => {
        setLoading(false);
        setFalse()
        window.location.reload();
      })

      ;
    refetch();

  };

  return (
    <>
      <Button tabIndex={-1} label={"Duplica per tutti"} onClick={() => setTrue()}>
        <UpdateIcon />
      </Button>
      <Dialog open={value} maxWidth="sm" fullWidth>


        <>
          <DialogContent>

            <Typography variant="h6" align="center">
              Vuoi duplicare i permessi per tutti i dipendenti?
            </Typography>
            <Typography variant="subtitle1" align="center">
              I permessi saranno duplicati con le stesse date e lo stesso tipo di permesso.
            </Typography>

          </DialogContent>

          <DialogActions>
            <Button label="ra.action.cancel" onClick={setFalse}>
              <IconCancel />
            </Button>
            <Button
              onClick={handleSubmit}
              label={loading ? "Caricamento..." : "Crea per tutti"}
              disabled={loading}
            />

          </DialogActions>
        </>
      </Dialog>
    </>
  );
};
